<!-- @format -->

<template>
	<!-- compacto = solo iconos (cabe en la tabla); grande = botones con texto (tarjetas) -->
	<div class="d-flex align-center" :class="grande ? 'flex-column w-100' : 'justify-end'">
		<template v-if="grande">
			<div class="d-flex w-100">
				<v-btn
					:href="orden.puedeVer ? orden.urlVer : null"
					:disabled="!orden.puedeVer"
					target="_blank"
					rel="noopener"
					x-large
					depressed
					color="success"
					class="text-none flex-grow-1 mr-2"
				>
					<v-icon left>mdi-eye-outline</v-icon>
					Ver OT
				</v-btn>
				<v-btn
					:href="botonCertificar.href"
					:disabled="botonCertificar.deshabilitado"
					x-large
					depressed
					:color="botonCertificar.color"
					class="text-none flex-grow-1"
				>
					<v-icon left>{{ botonCertificar.icono }}</v-icon>
					{{ botonCertificar.texto }}
				</v-btn>
			</div>
			<div class="d-flex w-100 mt-2 justify-end">
				<v-btn
					icon
					large
					:loading="compartiendo"
					:color="orden.compartida ? 'success' : 'grey darken-1'"
					aria-label="Compartir al portal"
					@click="$emit('compartir', orden)"
				>
					<v-icon>{{
						orden.compartida ? 'mdi-share-variant' : 'mdi-share-variant-outline'
					}}</v-icon>
				</v-btn>
				<v-btn
					icon
					large
					:loading="descargando"
					:disabled="!orden.puedeVer"
					color="primary"
					aria-label="Descargar PDF"
					@click="$emit('descargar', orden)"
				>
					<v-icon>mdi-file-pdf-box</v-icon>
				</v-btn>
				<v-btn icon large aria-label="Copiar enlace" @click="$emit('copiar', orden)">
					<v-icon>mdi-link-variant</v-icon>
				</v-btn>
				<v-btn
					icon
					large
					:href="orden.puedeEditar ? orden.urlEditar : null"
					:disabled="!orden.puedeEditar"
					target="_blank"
					rel="noopener"
					aria-label="Editar OT"
				>
					<v-icon>mdi-pencil-outline</v-icon>
				</v-btn>
			</div>
		</template>

		<template v-else>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						small
						v-bind="attrs"
						v-on="on"
						:href="orden.puedeVer ? orden.urlVer : null"
						:disabled="!orden.puedeVer"
						target="_blank"
						rel="noopener"
						color="success"
						aria-label="Ver OT"
					>
						<v-icon small>mdi-eye-outline</v-icon>
					</v-btn>
				</template>
				<span>{{ orden.puedeVer ? 'Ver OT' : 'Sin vista disponible' }}</span>
			</v-tooltip>

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						small
						v-bind="attrs"
						v-on="on"
						:href="botonCertificar.href"
						:disabled="botonCertificar.deshabilitado"
						:color="botonCertificar.colorIcono"
						:aria-label="botonCertificar.texto"
					>
						<v-icon small>{{ botonCertificar.icono }}</v-icon>
					</v-btn>
				</template>
				<span>{{
					botonCertificar.deshabilitado
						? 'Este tipo no se certifica aquí'
						: botonCertificar.texto
				}}</span>
			</v-tooltip>

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						small
						v-bind="attrs"
						v-on="on"
						:loading="compartiendo"
						:color="orden.compartida ? 'success' : 'grey darken-1'"
						aria-label="Compartir al portal"
						@click="$emit('compartir', orden)"
					>
						<v-icon small>{{
							orden.compartida ? 'mdi-share-variant' : 'mdi-share-variant-outline'
						}}</v-icon>
					</v-btn>
				</template>
				<span>{{
					orden.compartida ? 'Publicada en el portal del cliente' : 'Compartir al portal'
				}}</span>
			</v-tooltip>

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						small
						v-bind="attrs"
						v-on="on"
						:loading="descargando"
						:disabled="!orden.puedeVer"
						color="primary"
						aria-label="Descargar PDF"
						@click="$emit('descargar', orden)"
					>
						<v-icon small>mdi-file-pdf-box</v-icon>
					</v-btn>
				</template>
				<span>Descargar PDF</span>
			</v-tooltip>

			<v-menu offset-y left>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon small v-bind="attrs" v-on="on" aria-label="Más acciones">
						<v-icon small>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
				<v-list dense>
					<v-list-item
						:href="orden.urlEditar"
						:disabled="!orden.puedeEditar"
						target="_blank"
						rel="noopener"
					>
						<v-list-item-icon class="mr-2">
							<v-icon small>mdi-pencil-outline</v-icon>
						</v-list-item-icon>
						<v-list-item-title>Editar OT</v-list-item-title>
					</v-list-item>
					<v-list-item @click="$emit('copiar', orden)">
						<v-list-item-icon class="mr-2">
							<v-icon small>mdi-link-variant</v-icon>
						</v-list-item-icon>
						<v-list-item-title>Copiar enlace</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</template>
	</div>
</template>

<script>
export default {
	name: 'WorkOrderRowActions',
	props: {
		orden: { type: Object, required: true },
		grande: { type: Boolean, default: false },
		descargando: { type: Boolean, default: false },
		compartiendo: { type: Boolean, default: false },
	},
	computed: {
		botonCertificar() {
			if (this.orden.esCertificada)
				return {
					href: this.orden.puedeEditar ? this.orden.urlEditar : null,
					deshabilitado: !this.orden.puedeEditar,
					color: 'grey lighten-1',
					colorIcono: 'grey darken-1',
					icono: 'mdi-pencil-outline',
					texto: 'Editar',
				};
			return {
				href: this.orden.puedeCertificar ? this.orden.urlCertificar : null,
				deshabilitado: !this.orden.puedeCertificar,
				color: 'warning',
				colorIcono: 'warning',
				icono: 'mdi-certificate-outline',
				texto: 'Certificar',
			};
		},
	},
};
</script>

<style scoped>
.w-100 {
	width: 100%;
}
</style>
